import { PencilIcon } from '@grupoboticario/flora-react-icons';
import {
  CardInfo,
  CardInfoFieldWrapper,
  CardInfoField,
} from '../../sharedStyles';

import { CardInfoTitleSummary, EditButton, CardInfoFields } from '../styles';
import { formatCNPJ } from '../../../../../utils/format';

interface ICardSummary {
  editStep?: any;
  stateClaim: any;
}

export const Card04 = ({ editStep, stateClaim }: ICardSummary): JSX.Element => {
  return (
    <CardInfo>
      <CardInfoTitleSummary>
        Dados da loja
        {editStep && (
          <EditButton
            size="small"
            has="iconLeft"
            icon={<PencilIcon />}
            onClick={() => editStep(1)}
          >
            Editar
          </EditButton>
        )}
      </CardInfoTitleSummary>
      <CardInfoFields>
        <CardInfoFieldWrapper>
          <CardInfoField flex={4}>
            <span>Loja/Franquia:</span>
            <p>{stateClaim.step.step1?.lojas?.data.name || '-'}</p>
          </CardInfoField>
          <CardInfoField flex={2}>
            <span>Código PDV:</span>
            <p>{stateClaim.step.step1?.lojas?.data.code || '-'}</p>
          </CardInfoField>
          <CardInfoField flex={3}>
            <span>CNPJ:</span>
            <p>{formatCNPJ(stateClaim.step.step1?.lojas?.data.cnpj) || '-'}</p>
          </CardInfoField>
        </CardInfoFieldWrapper>
      </CardInfoFields>
    </CardInfo>
  );
};
